<template>
  <div class="about container">
    <div class="row">
          <div  class="col-lg-5 m-3 my-10">
     <h1 >{{ servizio.nome }} </h1>
     <div><p class="intestazione">{{ servizio.descrizione}}</p>
       </div>
     <h3 class="mb-5" v-if="presenzacontatti" >Contatti utili</h3>
     <p class="contatto my-1" v-for="c in servizio.listContatti" :key="c.id">{{c.nominativo}}: {{c.contatto}}</p>
      </div>
    <form-segnalazione v-if="!verificata&&!invalid" class="col-md-6 mt-12 mx-3 " v-bind:servizio="servizio"/>

    <div class="col-lg-6 mt-12 mr-10 mx-3 " v-if="verificata"><h3>La mail è stata verificata correttamente!</h3> <h3> La tua segnalazione verrà sottoposta a una valutazione prima di poter comparire nella lista sottostante</h3>
    <a href="" @click.prevent="goBack()">clicca qui per compilare un nuovo form</a></div>
    <div class="col-lg-6 mt-12 mx-3 " v-if="invalid"><h1>404</h1><h3>Link non valido!</h3> <h3>La mail è già stata validata il link non è più utilizzabile </h3>
    <a href="" @click.prevent="goBack()">clicca qui per compilare un nuovo form</a>
    </div>
    <list-segnalazioni class="col-lg-10 mt-10 mx-auto " v-bind:servizio="servizio"/>
    </div>
  </div>
</template>

<script>

import listSegnalazioni from '@/components/list-segnalazioni.vue'
import FormSegnalazione from '../components/form-segnalazione.vue'
// import ServiziDataService from '@/service/ServiziDataService.js'

export default {
  name: 'About',
  components: {
    listSegnalazioni,
    FormSegnalazione
  },
  data () {
    return {
      servizio: this.$store.getters.getServizio,
      presenzacontatti: false,
      verificata: false,
      invalid: false
    }
  },
  methods: {
    caricaInfoServizio (id) {
      this.$store.dispatch('caricaInfoServizio', id)
      console.log(this.$store.getters.getServizio, ' = ', this.servizio)
      this.$store.dispatch('setTheme', id)
    },
    set (id) {
      this.$store.dispatch('setComune', id)
      this.$store.dispatch('setTheme', id)
      // set title
      document.title = this.$store.getters.getServizio.nome
    },
    goBack () {
      this.verificata = false
      this.invalid = false
      this.$router.push({ name: 'About', params: { Sid: this.servizio.id } })
    }
  },
  created () {
    console.log('servizio ' + this.servizio.id)
    if (!this.servizio.id) {
      console.log('carica con param', this.$route.params.Sid)
      this.caricaInfoServizio(this.$route.params.Sid)
    }
  },

  computed: {
    servizioStore () { return this.$store.getters.getServizio },
    servizioComuneStore () { return this.$store.getters.getServizio.codiceComune },
    presenzaContatti () { return this.$store.getters.getServizio.listContatti }
  },

  mounted () {
    console.log('contatti ' + this.servizio.listContatti)
    const parametro = new URLSearchParams(window.location.search.substring(1))
    const verifica = parametro.get('segnalazione')
    console.log(verifica)
    if (verifica === 'mailverificata') {
      this.verificata = true
    }
    if (verifica === 'linkinvalido') {
      this.invalid = true
    }
  },
  watch: {
    $route: function (rot) {
      console.log('rot -->', rot)
      this.caricaInfoServizio(rot.params.Sid)
      if (!this.servizio.id) {
        this.$router.push({ name: 'NotFound' })
      }
    },
    servizioStore (news, old) {
      console.log('store old-->', old)
      console.log('store new-->', news)
      this.servizio = news
      this.set(news.codiceComune)
      if (!this.servizio.id) {
        this.$router.push({ name: 'NotFound' })
      }
    },
    servizioComuneStore (newcc, oldcc) {
      console.log('store old-->', oldcc)
      console.log('store new-->', newcc)
      this.set(newcc)
    },
    presenzaContatti (cont) {
      console.log('contatti->', cont)
      if (cont.length !== 0) {
        this.presenzacontatti = true
      }
      if (cont.length === 0) {
        this.presenzacontatti = false
      }
    }
  }

}
</script>
